<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-evaluation-360',
};
</script>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/page-evaluation.vue